module.exports = __webpack_public_path__ + "static/img/1-3.61fa415.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/zcx/assets/images/index-phone/1-3.png
// module id = THYX
// module chunks = 7